import { Routes, mapToCanActivate, mapToResolve } from '@angular/router';
import { AtLeastAdvisorRoleGuard } from '@next/core-lib/authorization';
import { LocationGuard } from '@next/core-lib/relationships';
import { Observable } from 'rxjs';

import { CreateReferenceValueSheetComponent } from './components/create-reference-value-sheet/create-reference-value-sheet.component';
import { ReferenceValueSheetOverviewComponent } from './components/reference-value-sheet-overview/reference-value-sheet-overview.component';
import { ReferenceValueSheetOverviewResolver } from './resolvers/reference-value-sheet-overview.resolver';

export const referenceValueSheetRoutes: Routes = [
  {
    path: '',
    component: ReferenceValueSheetOverviewComponent,
    canActivate: mapToCanActivate([LocationGuard]),
    resolve: {
      data: mapToResolve<Observable<boolean>>(ReferenceValueSheetOverviewResolver),
    },
  },
  {
    path: 'create',
    component: CreateReferenceValueSheetComponent,
    canActivate: mapToCanActivate([LocationGuard, AtLeastAdvisorRoleGuard]),
    resolve: {
      data: mapToResolve<Observable<boolean>>(ReferenceValueSheetOverviewResolver),
    },
  },
  {
    path: 'edit/:id',
    component: CreateReferenceValueSheetComponent,
    canActivate: mapToCanActivate([LocationGuard, AtLeastAdvisorRoleGuard]),
  },
  {
    path: 'view/:id',
    component: CreateReferenceValueSheetComponent,
    canActivate: mapToCanActivate([LocationGuard]),
  },
];
